import { render } from "./FormRow.vue?vue&type=template&id=8af0f95e"
import script from "./FormRow.vue?vue&type=script&lang=js"
export * from "./FormRow.vue?vue&type=script&lang=js"

import "./FormRow.vue?vue&type=style&index=0&id=8af0f95e&lang=scss"
script.render = render

export default script